import {
  ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output,
  SimpleChanges
} from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { NbDialogService } from '@nebular/theme';
import { CompaniesHistoricalWellsFormComponent } from './historical-wells-form.component';
import { CompaniesService } from '../companies.service';
import { filter, some } from 'lodash';
import { ModalConfirmComponent } from '../../../../shared/components/modals/confirm/modal-confirm.component';
import { LoadingOverlayService } from '../../../../shared/services';

@Component({
  selector: 'app-companies-historical-wells',
  templateUrl: './historical-wells.component.html',
  styleUrls: ['./historical-wells.component.scss']
})
export class CompaniesHistoricalWellsComponent implements OnInit, OnChanges {
  isAge;
  data: any[] = [];
  _companyId: number;
  checkAll: boolean = false;
  hideButton: boolean = false;
  isActionChange: boolean = true;
  _maxWells: number = 0;
  listSelectWells = [];
  tableSettings: any = {
    actions: {
      add: false,
      edit: false,
      delete: true,
      columnTitle: 'Action'
    },
    delete: {
      deleteButtonContent: '<i class="icon-delete app-danger-color-fg app-font-size-normal"></i>',
      confirmDelete: true,
    },
    hideSubHeader: true,
    pager: {
      perPage: 15,
    },
    columns: {
      wellName: {
        title: 'Name',
        type: 'string',
        width: '35%',
        sort: false,
      },
      country: {
        title: 'Country',
        type: 'string',
        width: '40%',
        sort: false,
      },
      wellAPI: {
        title: 'Well Api',
        type: 'number',
        width: '20%',
        sort: false,
      },
    },
  };
  @Input()
  set isAgePolicy(check){
    this.isAge=check;
  }

  @Input()
  set isCheckAll(check) {
    this.checkAll = check;
    if (this.checkAll || this.isAge=='Age') {

      this.tableSettings.actions.delete = false;
      
    } else {
      this.tableSettings.actions.delete = true;
    }
  }
 

  @Input()
  set listWells(list: any) {
    if (list) {
      this.dataSource.load(list);
      this.getData();
    }
  }

  @Input()
  set maxWells(num: number) {
    this._maxWells = num ? num : 0;
    if (this._maxWells <= this.data.length) {
      this.hideButton = true;
    } else {
      this.hideButton = false;
    }
  }

  @Input()
  set companyId(id) {
    if (id) {
      this._companyId = id;
    }
  }

  @Output() dataWells: EventEmitter<any> = new EventEmitter();

  dataSource: any = new LocalDataSource();

  constructor(private companiesService: CompaniesService,
    private ref: ChangeDetectorRef,
    private dialogService: NbDialogService,private loadingOverlayService:LoadingOverlayService) {

  }

  ngOnInit() {
    if (this._companyId) {
      this.getWellWithCompanyId(this._companyId);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.isCheckAll && !changes.isCheckAll.isFirstChange())||changes.isAgePolicy) {
      if (this.checkAll) {
        const data = this.getData().concat(this.listSelectWells);
        this.dataWells.emit(data);
        this.isActionChange = false;
        this.tableSettings.actions.delete = false;
        this.ref.detectChanges();
        this.isActionChange = true;
        // this.dataSource.load([]);
        this.listSelectWells = [];
      } 
      else if(this.isAge=='Age'){
        // this.isActionChange = false;
        // this.tableSettings.actions.delete = false;
        this.ref.detectChanges();
        // this.isActionChange = true;
        this.listSelectWells = [];
      }
      else {
        this.isActionChange = false;
        this.tableSettings.actions.delete = true;
        this.ref.detectChanges();
        this.isActionChange = true;
        if (this._companyId) {
          this.getWellWithCompanyId(this._companyId);
          this.dataSource.load([]);
          this.dataWells.emit(this.getData());
        }
      }
    }
  }

  onDeleteConfirm(item): void {
    this.dialogService.open(ModalConfirmComponent, {
      context: {
        config: {
          title: 'Delete',
          message: `Are you sure you want to delete <br> <b class="h6">${item.data.wellName}</b>?`,
          className: 'pop-delete common-page',
          btnTxtConfirm: 'Yes',
          btnTxtCancel: 'No',
          data: item.data,
        }
      }
    }).onClose.subscribe(res => {
      if (res.confirm) {
        this.dataSource.remove(item.data);
        this.listSelectWells.push(item.data);
        this.dataWells.emit(this.getData());
      }
    });
  }

  getData() {
    const data = this.dataSource.getAll();
    this.data = data['__zone_symbol__value'];
    this.listSelectWells = filter(this.listSelectWells, (item: any) => {
      return !some(this.data, ['id', item.id]);
    });
    if (this._maxWells <= this.data.length) {
      this.hideButton = true;
    } else {
      this.hideButton = false;
    }
    return this.data;
  }

  getSelectedWells() {
    const selectedWells = this.listSelectWells;
    return selectedWells.map(item => {
      delete item.selected;
      return item;
    });
  }

  onAddNew() {
    this.dialogService.open(CompaniesHistoricalWellsFormComponent, {
      context: {
        listWells: this.getSelectedWells(),
        maxWells: this._maxWells,
        countItemWells: this.data.length,
      },
      autoFocus: false,
    }).onClose.subscribe(res => {
      if (res) {
        res.forEach(obj => {
          this.dataSource.prepend(obj);
        });
        this.dataWells.emit(this.getData());
      }
    });
  }

  getWellWithCompanyId(id) {
    this.loadingOverlayService.show();
    this.companiesService.getWellByCompanyId(id).subscribe(
      (res) => {
        this.listSelectWells = res.result.items;
        this.getData();
        this.loadingOverlayService.hide();
      });
  }
 
}
